import React from 'react';
import ReactDOM from 'react-dom'; // Import ReactDOM
import {GlobalWarningSystem} from "Utility/GlobalWarningSystem.js";

export class FriendMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = { opening: false, showWarningSystem: false }; // Add showWarningSystem state
    this.ifRowIsPressed = this.ifRowIsPressed.bind(this);
    this.handleWarningSystemResponse = this.handleWarningSystemResponse.bind(this); // Handle response
  }

  ifRowIsPressed() {
    this.setState({ showWarningSystem: true }); // Show the warning system
  }

    handleWarningSystemResponse(confirmed) {
        this.setState({ showWarningSystem: false }); // Hide warning system

        if (confirmed) {
            // User confirmed, do something
            console.log("User confirmed!");
            // ... your logic ...
        } else {
            // User cancelled, do something else
            console.log("User cancelled!");
            // ... your logic ...
        }

    }

  render() {
    if (!this.state.opening) { // Use ! for boolean check
      return <div>close <button onClick={() => this.setState({ opening: true })}>Open</button></div>; // Button to open
    } else {
      return (
        <div>
          <row>open</row>
          <button onClick={this.ifRowIsPressed}>Remove</button> {/* Call function */}
          {this.state.showWarningSystem && ( // Conditionally render
            <GlobalWarningSystem onResponse={this.handleWarningSystemResponse} />
          )}
        </div>
      );
    }
  }
}
